<div #messagesContainer class="flex-1 overflow-y-auto px-4 sm:px-6 py-4">
  <div class="max-w-3xl mx-auto space-y-1">
    @for (message of messages(); track message.id) {
      <app-chat-message [message]="message" (contentLoaded)="onContentLoaded()"></app-chat-message>
    }

    <!-- Typing indicator when AI is responding -->
    @if (isSending()) {
      <div class="flex items-center gap-3 py-2">
        <div class="flex items-center gap-1.5 px-4 py-3 bg-gray-100 rounded-2xl">
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
          <span class="typing-dot"></span>
        </div>
        <span class="text-xs sm:text-sm text-gray-500">AI is thinking...</span>
      </div>
    }
  </div>
</div>
